Vue.component('chat-header', {
	props: ['options','labellang'],
	template:
		'<transition v-if="isActive" name="bounce" enter-active-class="bounceInDown" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">'+
				'<div id="chat-header" class="row no-gutters">'+
				//	'<div class="col-xs-1 col-sm-1 no-gutters"></div>'+
					'<div v-if="!options.headerLogo" v-bind:class="[ (isLargeHeader && isRainbowHeader) ?  colNameLarge : colNameSmall]">'+
						'<img :src="getImgAgent()"  :class="{ \'trasfering\': inTransfer }" class="img-agent img-responsive"  onerror="svgOnError()">'+
						'<p v-if="getAgentName()" class="agent-name" :class="{ \'trasfering\': inTransfer }" :title="getAgentName()" >{{ getAgentName() }}</p>'+
					'</div>'+
					'<div v-else style="width: 100%;text-align: -webkit-center; padding-left: 0;" v-bind:class="[ (isLargeHeader && isRainbowHeader) ?  colNameLarge : colNameSmall]">'+
						 /*'<img :src="getImgAgent()"  :class="{ \'trasfering\': inTransfer }" class="img-agent img-responsive"  onerror="svgOnError()">'+*/
		 				 '<img style="max-height: 43px !important;" src="../img/convy_logo_full_white.png"  class=" img-responsive">'+
						 // '<p v-if="getAgentName()" class="agent-name" :class="{ \'trasfering\': inTransfer }" :title="getAgentName()" >{{ getAgentName() }}</p>'+
					'</div>'+
					'<div v-if="!isLargeHeader" class="col-xs-4 col-sm-4 no-gutters headerBtns">'+
					'<button @click="openVideoEscalation" :disabled="disabledClick" id="videoEscalation" :class="{ \'disabled\': disabledVideo }" v-if="getVideoActive()" rel="tooltip" data-placement="left" :title="text.tooltipVideoEscalation"><i class="material-icons">&#xE04B;</i></button>'+
					'<button @click="openAudioEscalation" :disabled="disabledClick" id="audioEscalation" :class="{ \'disabled\': disabledAudio }" v-if="getAudioActive()" rel="tooltip" data-placement="left" :title="text.tooltipAudioEscalation"><i class="material-icons">&#xE029;</i></button>'+
					'<button @click="openMenu" id="menu" v-if="isMenuActive" rel="tooltip" ><i class="material-icons">&#xE5D2;</i></button>'+
					//'<button @click="openRepo" id="repo" v-if="getRepositoryActive()" rel="tooltip" data-placement="left" :title="text.tooltipRepo"><i class="material-icons">folder</i></button><span class="badge badge-repository badge-pill badge-primary" v-if="getRepositoryActive()">{{counterRepoBadge}}</span>'+
					'</div>'+
					'<div v-if="!isRainbowHeader" class="col-xs-4 col-sm-4 no-gutters headerBtns">'+
					'<button @click="openRainbowVideoEscalation" :disabled="disabledClick" id="videoEscalation" :class="{ \'disabled\': disabledVideo }" v-if="getVideoActive()" rel="tooltip" data-placement="left" :title="text.tooltipVideoEscalation"><i class="material-icons">&#xE04B;</i></button>'+
					'<button @click="openRainbowAudioEscalation" :disabled="disabledClick" id="audioEscalation" :class="{ \'disabled\': disabledAudio }" v-if="getAudioActive()" rel="tooltip" data-placement="left" :title="text.tooltipAudioEscalation"><i class="material-icons">&#xE029;</i></button>'+
					'<button @click="openMenu" id="menu" v-if="isMenuActive" rel="tooltip" ><i class="material-icons">&#xE5D2;</i></button>'+
					//'<button @click="openRepo" id="repo" v-if="getRepositoryActive()" rel="tooltip" data-placement="left" :title="text.tooltipRepo"><i class="material-icons">folder</i></button><span class="badge badge-repository badge-pill badge-primary" v-if="getRepositoryActive()">{{counterRepoBadge}}</span>'+
					'</div>'+
				'</div>'+
		'</transition>',
	data:function(){
		return {
			agentName:'',
			isActive:false,
			isEscaltion:false,
			isf2f:true,
			typeEscaltaion:null,
			disabledVideo:false,
			disabledAudio:false,
			disabledClick:false,
			isMenuActive:false,
			isRepoActive: true,
			isPopOver:false,
			inTransfer:false,
			buttonAreaSize: "",
			repositoryItems: [],
			showRepoBadge: false,
			counterRepoBadge: '',
			lastCounterRepoBadge: 0,
			text:{
				tooltipVideoEscalation:this.labellang.tooltipVideoEscalation,
				tooltipAudioEscalation:this.labellang.tooltipAudioEscalation,
				tooltipRepo:this.labellang.tooltipRepo,

			},
			colNameSmall: "col-xs-7 col-sm-7 no-gutters offset-top-10 padding-left-15",
			colNameLarge: "col-xs-10 col-sm-10 no-gutters offset-top-10 padding-left-15"
		}
	},
	computed: {
		getButtonArea: function () {
			return this.options.buttonAreaSize;
		},
		isLargeHeader: function () {
			return this.options.largeNameHeader;
		},
		isRainbowHeader: function () {
			return this.options.rainbowHeader;
		}
	},
	created: function () {
		var that = this;
		this.isAllowClose();


		this.$parent.$on('onShowHeader', function (val) {
			that.contentShow(val);
			//XXX multitab: se non allineo anche i flag per i bottoni audio/video
			//dopo il restart li vedo sempre disabilitati
			that.recallButton(!val);
			//XXX multitab: fine
		})

		this.callTooltip();

		this.$parent.$on('onRestartButtonVideoAudio', function (val) {
			that.recallButton(val);
		})

		this.$parent.$on('onDisableHeader', function (boolean) {
			that.recallButton(boolean);
		});

		this.$parent.$on('onTrasfering', function () {
			that.recallButton(true);
			that.setTransfer(true);
		});
		this.$parent.$on('restartTransferEnd', function () {
			that.recallButton(false);
			that.setTransfer(false);
		});

		this.$parent.$on('onTrasferEnd', function () {
			that.recallButton(false);
			that.setTransfer(false);
		});

		this.$parent.$on('onPause', function (msg) {
			that.recallButton(true);
		})
		this.$parent.$on('onResume', function (msg) {
			if (that.isEscalation) {
			that.recallButton(true);
		//	console.log('resume con escalation true');
			}
			else {
			that.recallButton(false);
		//	console.log('resume con escalation false');
			}
		})

	},
	mounted: function() {

		var that = this;

		// that.agentName = that.options.internal.agentDisplayName;

		bus.$on('repo'), function(val) {
			this.isRepoActive = val;
		};

		if (this.options.internal.isConvy == true || this.options.isVirtualAgent == true) {
			that.isRepoActive = false;
		};

		this.$parent.$on('onEscalation', function (val) {
		//	console.log('esclation --> '+val);
			that.isEscalation = val;
			that.recallButton(val);
		});

		bus.$on('isRingingEvent', function (val) {
			if(val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isQueuedEvent', function (val) {
			if(val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isRunningEvent', function (val) {
			if(val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isF2F', function (val) {
			that.isf2f = val;
		});

		bus.$on('addRepoItem', function(repo) {
		   that.showRepoButton(repo);
        });

		this.$parent.$on('isRingingEvent', function (val) {
			if(val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isQueuedEvent', function (val) {
			if(val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isRunningEvent', function (val) {
			if(val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isF2F', function (val) {
			that.isf2f = val;
		});



	},
	methods:{
		svgOnError:function(){
			console.log('Fail to load svg headers');
		},
		getImgAgent: function(){
			if(this.options.isVirtualAgent == true){
				return this.options.logo;
			}
			else{
				return this.options.imgAgent;
			}
		},
		contentShow:function(val){
			this.isActive = val;
			this.callTooltip();
		},
		recallButton:function(val){
			this.disabledVideo = val;
			this.disabledAudio = val;
			this.disabledClick = val;
		},
		callTooltip:function(){
			Vue.nextTick(function () {
				$('[rel="tooltip"]').tooltip();
			})
		},
		hideTooltip:function(){
			$('[rel="tooltip"]').tooltip("hide");
		},
		getAgentName:function(){
			if(!this.isf2f) {
				if(this.options.configuration.channel == "chat") {
					return this.options.internal.agentDisplayName;
				} else {
					return this.agentName;
				}
			} else {
				return this.options.internal.agentDisplayName;
			}
		},
		isAllowClose:function(){
			return this.options.configuration.allowCloseSession;
		},
		setBackHistory:function(){
			this.options.internal.isMobile = true;//serve per poter abilitare la backHistory
			this.$parent.backHistory();
		},
		getVideoActive:function(){
			return  this.options.configuration.allowVideoEscalation;
		},
		getAudioActive:function(){
			return this.options.configuration.allowAudioEscalation;
		},
		getSharingActive:function(){
			return this.options.configuration.allowShareDoc;
		},
		getScreenSharingActive:function(){
			return this.options.configuration.allowShareScreen;
		},
		getEmailActive:function(){
			return this.options.configuration.allowEmailReservation;
		},
		getRepositoryActive:function() {
			if (this.options.internal.isConvy == true || this.options.isVirtualAgent == true){
				return false;
			}else{
				return true;
			}
			
		},
		openMenu:function(){
			// TODO OPEN MENU
		},
		showRepoButton: function (repo) {

			this.repositoryItems = repo;
			this.isRepoActive = true;
			this.showRepoBadge = true;
			this.counterRepoBadge = repo.length - this.lastCounterRepoBadge;

		},
		openRepo:function(){
			this.hideTooltip();
			this.lastCounterRepoBadge = this.repositoryItems.length;
			this.counterRepoBadge = '';
			bus.$emit("onOpenRepo",true);
		},
		setTransfer:function(val){
			this.inTransfer = val;
		},
		openAudioEscalation:function(){
			this.hideTooltip();
			this.disabledVideo =  true;
			this.disabledAudio =  true;
			this.disabledClick = true;
			bus.$emit("onAudioEscalation",true);
			bus.$emit("onVideoEscalation",false);
			bus.$emit("onEscalation",true); // call a event on chat main that resazie chat
			this.typeEscaltaion = "audio";
			this.isEscalation = true;
			this.$parent.escalationRequest(this.typeEscaltaion,this.isEscalation);
		},
		openVideoEscalation:function(){
			this.hideTooltip();
			this.disabledAudio =  true;
			this.disabledVideo =  true;
			this.disabledClick = true;

			bus.$emit("onVideoEscalation",true);
			bus.$emit("onAudioEscalation",false);
			bus.$emit("onEscalation",true);
			this.typeEscaltaion = "video";
			this.isEscalation = true;
			this.$parent.escalationRequest(this.typeEscaltaion,this.isEscalation);
		},
        openRainbowAudioEscalation:function(){
            this.hideTooltip();
            this.disabledVideo =  true;
            this.disabledAudio =  true;
            this.disabledClick = true;

            //TODO questo emit è uguale a quello sotto ma con il tipo diverso
            bus.$emit("onRainbowAudioEscalation",false);
            bus.$emit("onRainbowVideoEscalation",true);
            bus.$emit("onEscalation",true);

            this.typeEscaltaion = "audio";
            this.isEscalation = true;
            this.$parent.rainbowEscalationRequest(this.typeEscaltaion,this.isEscalation);
        },
        openRainbowVideoEscalation:function(){
            this.hideTooltip();
            this.disabledAudio =  true;
            this.disabledVideo =  true;
            this.disabledClick = true;

            //TODO questo emit è uguale a quello sopra ma con il tipo diverso
            bus.$emit("onRainbowAudioEscalation",false);
            bus.$emit("onRainbowVideoEscalation",true);
            bus.$emit("onEscalation",true);

            this.typeEscaltaion = "video";
            this.isEscalation = true;
            this.$parent.rainbowEscalationRequest(this.typeEscaltaion,this.isEscalation);
        },
		disable:function(boolean) {
			this.disabled = boolean;
		}

	}

})
